import { render, staticRenderFns } from "./MOMOAccounts.vue?vue&type=template&id=37e13379"
import script from "./MOMOAccounts.vue?vue&type=script&lang=js"
export * from "./MOMOAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports